import React, { useState, useEffect } from 'react';
import { FaPhone, FaWhatsapp, FaMapMarkerAlt, FaClock, FaEnvelope, FaUser, FaCalendarAlt } from 'react-icons/fa';
import styles from './Contact.module.css';

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    massageType: '',
    date: ''
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    const section = document.querySelector(`.${styles.contact}`);
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `Hi, I would like to book an appointment.
Name: ${formData.name}
Phone: ${formData.phone}
Massage Type: ${formData.massageType}
Preferred Date: ${formData.date}`;
    
    window.open(`https://wa.me/919288595970?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleCall = () => {
    window.open('tel:+919288595970', '_self');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919288595970?text=Hi, I would like to know more about your services', '_blank');
  };

  return (
    <section className={styles.contact}>
      <div className={styles.container}>
        <div className={`${styles.sectionHeader} ${isVisible ? styles.fadeIn : ''}`}>
          <h2 className={styles.title}>Get In Touch</h2>
          <p className={styles.subtitle}>Ready to experience ultimate relaxation? Contact us today</p>
        </div>

        <div className={styles.contactContent}>
          <div className={`${styles.contactInfo} ${isVisible ? styles.slideLeft : ''}`}>
            <div className={styles.infoCard}>
              <h3 className={styles.cardTitle}>Contact Information</h3>
              
              <div className={styles.infoItem}>
                <FaPhone className={styles.infoIcon} />
                <div>
                  <span className={styles.infoLabel}>Phone</span>
                  <span className={styles.infoValue}>+91 92885 95970</span>
                </div>
              </div>

              <div className={styles.infoItem}>
                <FaClock className={styles.infoIcon} />
                <div>
                  <span className={styles.infoLabel}>Open Hours</span>
                  <span className={styles.infoValue}>24 Hours Daily</span>
                </div>
              </div>

              <div className={styles.infoItem}>
                <FaMapMarkerAlt className={styles.infoIcon} />
                <div>
                  <span className={styles.infoLabel}>Address</span>
                  <span className={styles.infoValue}>
                    4th Floor, Plot no 132, Khora Rd, near Sarla Hotel Inn, opposite Tower I, Block B, Industrial Area, Sector 62, Noida, Uttar Pradesh 201020
                  </span>
                </div>
              </div>

              <div className={styles.actionButtons}>
                <button className={styles.callBtn} onClick={handleCall}>
                  <FaPhone /> Call Now
                </button>
                <button className={styles.whatsappBtn} onClick={handleWhatsApp}>
                  <FaWhatsapp /> WhatsApp
                </button>
              </div>
            </div>

            <div className={styles.mapContainer}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.0234567890123!2d77.3666667!3d28.6166667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM2JzU5LjQiTiA3N8KwMjInMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                width="100%"
                height="250"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Arpita Spa Location"
              ></iframe>
            </div>
          </div>

          <div className={`${styles.enquiryForm} ${isVisible ? styles.slideRight : ''}`}>
            <div className={styles.formCard}>
              <h3 className={styles.formTitle}>Book Your Appointment</h3>
              <p className={styles.formSubtitle}>Fill out the form and we'll get back to you shortly</p>

              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.inputGroup}>
                  <FaUser className={styles.inputIcon} />
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className={styles.input}
                  />
                </div>

                <div className={styles.inputGroup}>
                  <FaPhone className={styles.inputIcon} />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className={styles.input}
                  />
                </div>

                <div className={styles.inputGroup}>
                  <FaEnvelope className={styles.inputIcon} />
                  <select
                    name="massageType"
                    value={formData.massageType}
                    onChange={handleInputChange}
                    required
                    className={styles.select}
                  >
                    <option value="">Select Massage Type</option>
                    <option value="Body Massage">Body Massage</option>
                    <option value="Aromatherapy Massage">Aromatherapy Massage</option>
                    <option value="Swedish Massage">Swedish Massage</option>
                    <option value="Thai Massage">Thai Massage</option>
                    <option value="Couple Massage">Couple Massage</option>
                    <option value="Home Service">Home Service</option>
                  </select>
                </div>

                <div className={styles.inputGroup}>
                  <FaCalendarAlt className={styles.inputIcon} />
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                    className={styles.input}
                    min={new Date().toISOString().split('T')[0]}
                  />
                </div>

                <button type="submit" className={styles.submitBtn}>
                  <FaWhatsapp /> Send Enquiry
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <p>&copy; 2024 Arpita Spa & Home Massage - Noida. All rights reserved.</p>
          <p>Experience luxury, comfort, and rejuvenation at its finest.</p>
        </div>
      </footer>
    </section>
  );
};

export default Contact;